var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthTemplate',[_c('LoginFormVersion',{attrs:{"slot":"body","tracking":"login"},slot:"body"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }